import { z } from "zod";
import { recipeContentV1Schema } from "./studio.js";
/** A retained Cookbook recipe revision. Restores create a new revision; they never overwrite this row. */
export const bookRecipeRevisionV1Schema = z
    .object({
    version: z.literal(1),
    recipeId: z.string().min(1).max(160),
    revision: z.number().int().positive(),
    parentRevision: z.number().int().nonnegative(),
    content: recipeContentV1Schema,
    createdBy: z.string().min(1).max(160),
    createdAt: z.string().datetime(),
    restoredFromRevision: z.number().int().positive().optional(),
})
    .strict();
export const bookRecipeRevisionListV1Schema = z
    .object({
    data: z.array(bookRecipeRevisionV1Schema).max(50),
    meta: z
        .object({
        count: z.number().int().nonnegative().max(50),
        nextCursor: z.string().min(1).max(4096).nullable(),
    })
        .strict(),
})
    .strict();
export const restoreBookRecipeRevisionCommandV1Schema = z
    .object({
    expectedRevision: z.number().int().nonnegative(),
})
    .strict();
//# sourceMappingURL=book-recipe-revisions.js.map